// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_2VWO9HRXI2","newsFrame":"_5cHj9eObVS"};